// @flow
import type { DriverLibraryState } from 'reducers/library';
import type { CohortDriver } from 'types/entities';

import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router';
import { DRIVER_BEHAVIOURS_NAMES } from 'utils/library-utils';

type Props = {
  drivers: DriverLibraryState,
  deleteDriver: Function,
};

export default function DriversTable(props: Props) {
  return (
    <div>
      <h2 className="title is-4">
        Library Drivers
        <Link
          to="/drivers/new"
          className="button is-primary is-small is-pulled-right"
          title="Add driver to library"
          aria-label="Add driver to library"
        >
          <span className="icon is-small" aria-hidden="true">
            <i className="fa fa-plus" />
          </span>
        </Link>
      </h2>
      <table className="table is-bordered is-striped">
        <thead>
          <tr>
            <th>Gamma ID</th>
            <th>Name</th>
            <th>Device ID</th>
            <th>IMEI</th>
            <th>Behaviour</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(props.drivers).map((cohortDriverID: string) => {
            const driver: CohortDriver = props.drivers[cohortDriverID];
            const editDriverButtonTitle = `Edit driver ${cohortDriverID}`;
            const deleteDriverButtonTitle = `Delete driver ${cohortDriverID} from cohort`;
            return (
              <tr key={cohortDriverID}>
                <td>{cohortDriverID}</td>
                <td>{driver.name || '-'}</td>
                <td className="word-wrap">{driver.deviceID || '-'}</td>
                <td className="word-wrap">{driver.imei || '-'}</td>
                <td>{DRIVER_BEHAVIOURS_NAMES[_.get(driver, 'behaviour.type')]}</td>
                <td>
                  <div className="field is-grouped">
                    <p className="control">
                      <Link
                        to={`/drivers/${cohortDriverID}/edit`}
                        className="button is-info is-small is-outlined"
                        title={editDriverButtonTitle}
                        aria-label={editDriverButtonTitle}
                      >
                        <span className="icon is-small" aria-hidden="true">
                          <i className="fa fa-pencil" />
                        </span>
                      </Link>
                    </p>
                    <p className="control">
                      <button
                        className="button is-small is-outlined is-danger"
                        title={deleteDriverButtonTitle}
                        aria-label={deleteDriverButtonTitle}
                        onClick={() => {
                          /* eslint-disable no-alert */
                          if (confirm(`Are you sure you want to remove Driver ${cohortDriverID}?`)) {
                            props.deleteDriver(cohortDriverID);
                          }
                        }}
                      >
                        <span className="icon is-small" aria-hidden="true">
                          <i className="fa fa-trash" />
                        </span>
                      </button>
                    </p>
                  </div>
                </td>
              </tr>
            );
          })}
          {_.isEmpty(props.drivers) && <tr>
            <td colSpan={999} className="has-text-centered">No drivers added.</td>
          </tr>}
        </tbody>
      </table>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/views/library/drivers/DriversTable.jsx
 **/